/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon64Regular = forwardRef('MediaUiAPlayPauseIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 15.471c0-3.553 3.924-5.704 6.92-3.794l25.92 16.529c2.774 1.769 2.774 5.82 0 7.588L9.92 52.324C6.923 54.233 3 52.081 3 48.528V15.471Zm5.306-1.265A1.5 1.5 0 0 0 6 15.471V48.53a1.5 1.5 0 0 0 2.306 1.265l25.92-16.53a1.5 1.5 0 0 0 0-2.529L8.307 14.206Z" }),
        React.createElement("path", { d: "M46.5 11a1.5 1.5 0 0 1 1.5 1.5v39a1.5 1.5 0 0 1-3 0v-39a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M60 12.5a1.5 1.5 0 1 0-3 0v39a1.5 1.5 0 0 0 3 0v-39Z" })));
});
